import store from '@/store'

export const addErrorLog = (err, vm, info) => {
  // eslint-disable-next-line no-console
  console.log('-------err-------', err)
  if (err && err.message != '服务器发生错误') {
    console.error('腾宇一号错误拦截:', err)
    const url = window.location.href

    const params = {
      level: 4,
      message: err.message || err,
      url,
    }
    if (info === 'request') {
      params.level = 3
      params.config = err.config
      params.data = err.data
    }
    if (err.level) params.level = err.level

    if (info === 'request' && err.config && /Append/.test(err.config.url)) {
      return
    }

    store.dispatch('errorLog/LogAppend', params).then(() => {})
  }
}
